import React, { useRef, useEffect, useState } from "react";
import "../style/Logo.scss";

const Logo = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      // Set canvas size
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
  
      // Create nodes
      const nodes = [];
      const numNodes = 50;
      const mouse = { x: null, y: null, radius: 200 }; // Increase radius for stronger interaction
  
      class Node {
        constructor(x, y, dx, dy, radius) {
          this.x = x;
          this.y = y;
          this.dx = dx;
          this.dy = dy;
          this.radius = radius;
        }
  
        draw() {
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
          ctx.fillStyle = "rgba(179, 179, 179, 0.87)"; // Light, semi-transparent nodes
          ctx.fill();
        }
  
        update() {
          // Bounce off walls
          if (this.x + this.radius > canvas.width || this.x - this.radius < 0) {
            this.dx = -this.dx;
          }
          if (this.y + this.radius > canvas.height || this.y - this.radius < 0) {
            this.dy = -this.dy;
          }
  
          // Move away from mouse
          const dx = this.x - mouse.x;
          const dy = this.y - mouse.y;
          const distance = Math.sqrt(dx * dx + dy * dy);
  
          if (distance < mouse.radius + this.radius) {
            if (mouse.x < this.x && this.x < canvas.width - this.radius * 2) {
              this.x += 2;
            }
            if (mouse.x > this.x && this.x > this.radius * 2) {
              this.x -= 2;
            }
            if (mouse.y < this.y && this.y < canvas.height - this.radius * 2) {
              this.y += 2;
            }
            if (mouse.y > this.y && this.y > this.radius * 2) {
              this.y -= 2;
            }
          }
  
          this.x += this.dx;
          this.y += this.dy;
  
          this.draw();
        }
      }
  
      // Initialize nodes
      for (let i = 0; i < numNodes; i++) {
        const radius = Math.random() * 3 + 1;
        const x = Math.random() * (canvas.width - radius * 2) + radius;
        const y = Math.random() * (canvas.height - radius * 2) + radius;
        const dx = (Math.random() - 0.5) * 2;
        const dy = (Math.random() - 0.5) * 2;
        nodes.push(new Node(x, y, dx, dy, radius));
      }
  
      // Animation loop
      function animate() {
        requestAnimationFrame(animate);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
  
        nodes.forEach((node) => node.update());
      }
  
      animate();
  
      // Mouse move event
      window.addEventListener("mousemove", (e) => {
        mouse.x = e.x;
        mouse.y = e.y;
      });
  
      // Mouse leave event
      window.addEventListener("mouseout", () => {
        mouse.x = null;
        mouse.y = null;
      });
  
      // Cleanup
      return () => {
        window.removeEventListener("mousemove", () => {});
        window.removeEventListener("mouseout", () => {});
      };
    }, []);

  return (
    <div className="logo-container">
      <canvas ref={canvasRef} className="background-canvas"></canvas>
      <div className="logo-icons">
        <img src="/logo/evas.png" alt="Logo" />
      </div>
    </div>
  );
};

export default Logo;
